import { render, staticRenderFns } from "./ModalPersonalizationEditor.vue?vue&type=template&id=719fc540&scoped=true"
import script from "./ModalPersonalizationEditor.vue?vue&type=script&lang=js"
export * from "./ModalPersonalizationEditor.vue?vue&type=script&lang=js"
import style0 from "./ModalPersonalizationEditor.vue?vue&type=style&index=0&id=719fc540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719fc540",
  null
  
)

export default component.exports